"use strict";import{InfieldButton as e}from"./src/InfieldButton.js";customElements.define("sp-infield-button",e);
//# sourceMappingURL=sp-infield-button.js.map
